import { formatInTimeZone } from "date-fns-tz";
import { CalendarDays, Clock3, MapPin } from "lucide-react";
import "./GameInfoSection.css";

function GameInfoSection({ game }) {
  const gameDate = game?.date
    ? formatInTimeZone(game.date, "America/Los_Angeles", "MMM d, yyyy")
    : "TBD";

  const gameTime =
    game?.date && game?.time
      ? formatInTimeZone(
        `${game.date}T${game.time}`,
        "America/Los_Angeles",
        "h:mm a"
      )
      : "TBD";

  const location = game?.location || "TBD";

  return (
    <div className="game-info-section">
      {game?.video_url && (
        <div className="game-info-video-wrap">
          <iframe
            className="game-info-video"
            src={game.video_url}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Game Video"
            onError={() =>
              alert("There was an error loading the video. Please try again later.")
            }
          />
        </div>
      )}

      <div className="game-info-title-row">
        <h2 className="game-info-title">Game Info</h2>
      </div>

      <div className="game-info-meta-grid">
        <div className="game-info-meta-card">
          <span className="game-info-meta-icon">
            <MapPin size={22} strokeWidth={2.2} />
          </span>
          <div>
            <span className="game-info-meta-label">Location</span>
            <strong>{location}</strong>
          </div>
        </div>

        <div className="game-info-meta-card">
          <span className="game-info-meta-icon">
            <Clock3 size={22} strokeWidth={2.2} />
          </span>
          <div>
            <span className="game-info-meta-label">Game Time</span>
            <strong>{gameTime}</strong>
          </div>
        </div>

        <div className="game-info-meta-card">
          <span className="game-info-meta-icon">
            <CalendarDays size={22} strokeWidth={2.2} />
          </span>
          <div>
            <span className="game-info-meta-label">Date</span>
            <strong>{gameDate}</strong>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GameInfoSection;